"use client";
import { Container, Skeleton, createStyles } from "@mantine/core";
import React from "react";
import { Carousel } from "@mantine/carousel";
import { ArrowLeft, ArrowRight } from "@/components/Svg";

const useStyles = createStyles((theme) => ({
  root: {},
  viewport: {
    height: "100%",
  },
  controls: {
    justifyContent: "flex-end",
    top: "-100px",
    maxWidth: "1180px",
    marginRight: "auto",
  },
  control: {
    boxShadow: "none",
    border: "transparent",
    color: theme.colors.primary,
    backgroundColor: theme.colors.primaryOpacity,
    "&:first-child": {
      borderRadius: "6px 0 0 6px",
      padding: "13px 8px 13px 18px",
    },
    "&:nth-child(2)": {
      borderRadius: "0 6px 6px 0",
      padding: "13px 18px 13px 8px",
    },
    "@media (max-width: 610px)": {
      display: "none",
    },
  },
  indicators: {
    bottom: "-25px",
    maxWidth: "1180px",
    marginRight: "auto",
    "@media (min-width: 610px)": {
      display: "none",
    },
  },

  indicator: {
    backgroundColor: theme.colors.primary,
    width: "12px",
    height: "12px",
  },
}));

const OurPartnersSkeleton = () => {
  const { classes } = useStyles();

  function splitArrayIntoChunks(array, chunkSize) {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
  }

  return (
    <Container className="py-[90px]">
      <div>
        <Skeleton height={30} width={80} />
        <Skeleton height={70} width={250} className="mt-1" />
        <Skeleton height={20} className="max-w-[320px] mt-2" />
      </div>
      <div className="mt-6">
        <Carousel
          classNames={{
            root: classes.root,
            controls: classes.controls,
            control: classes.control,
            indicators: classes.indicators,
            indicator: classes.indicator,
            viewport: classes.viewport,
          }}
          withIndicators
          loop
          slideSize="20%"
          previousControlIcon={<ArrowLeft />}
          nextControlIcon={<ArrowRight />}
          previousControlLabel="Previous"
          nextControlLabel="Next"
          align="start"
          breakpoints={[
            { maxWidth: "md", slideSize: "50%" },
            { maxWidth: "sm", slideSize: "100%" },
          ]}
        >
          {splitArrayIntoChunks(Array.from(Array(10)), 2).map((item, index) => (
            <Carousel.Slide key={index}>
              <div className="h-[216px] w-full mx-1 flex flex-col justify-between">
                <div className="relative h-[100px] mx-1 rounded-lg overflow-hidden">
                  <Skeleton height={100} />
                </div>{" "}
                <div className="relative h-[100px] mx-1 rounded-lg overflow-hidden">
                  <Skeleton height={100} />
                </div>
              </div>
            </Carousel.Slide>
          ))}
        </Carousel>
      </div>
    </Container>
  );
};

export default OurPartnersSkeleton;
